let quotes = [
    {
        text: "There’s no sense in going out of your way to get somebody to like you.",
        quoted_by: "Ash",
    },
    {
        text: "Make your wonderful dream a reality, and it will become your truth.",
        quoted_by: "N",
    },
    { text: "Pi, ka, chuuu.", quoted_by: "Pikachu" },
    {
        text: "That’s okay, Brock, you’ll find lots of other girls to reject you!",
        quoted_by: "Ash",
    },
    {
        text: "You see, sometimes friends have to go away, but a part of them stays behind with you.",
        quoted_by: "Ash",
    },
    {
        text: "I’m totally unprepared to deal with life’s realities.",
        quoted_by: "Meowth",
    },
    {
        text: "I’ll use my trusty frying pan… as a drying pan!",
        quoted_by: "Brock",
    },
    {
        text: "Don’t you know that love is the most important thing in the whole world?",
        quoted_by: "Misty",
    },
    {
        text: "Oh, I left my motorcycle at the front desk.",
        quoted_by: "Officer Jenny",
    },
    { text: "My name is Caesar Salad.", quoted_by: "Brock" },
    {
        text: "Team Rocket blasting off at the speed of light.",
        quoted_by: "Jessie",
    },
];
export { quotes };
